module.exports = __webpack_public_path__ + "3fdcb30f17c98468d6b0dc0ddc518aa2.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/wave-right-2.png
// module id = 3315
// module chunks = 0